import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';

// Bump when locale JSON keys change so http-backend does not serve a stale cached file.
const APP_I18N_VERSION = '20260810l'

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'es',
    debug: false,
    ns: ['common','notifications','validations'],
    defaultNS: 'common',
    backend: {
      // Bust browser cache when locale files change (i18next-http-backend).
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${APP_I18N_VERSION}`,
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n;